import sliderHandler from './slider-handler.svg';

export const iconsAb = {
	sliderHandler,
};
